// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

export { default } from './Overview';



// WEBPACK FOOTER //
// ./app/repair/Overview/index.js